module.exports = {
  findPwd: {
    find: '找回密码',
    userName: '手机号或邮箱',
    error_userName_1: '请输入手机号或邮箱',
    error_userName_2: '该号码未绑定任何投影仪账号',
    error_userName_3: '该邮箱未绑定任何投影仪账号',
    get_code: '发送验证码',
    get_code_tip: '点击发送验证码',
    get_code_tip_re: '秒后重新发送',
    code: '验证码',
    error_code_1: '请输入验证码',
    error_code_2: '获取验证码次数已达今日上限，请明天再试！',
    error_code_3: '验证码错误',
    error_code_4: '验证码已经发送，10分钟内有效',
    error_code_5: '验证码获取频率频繁，请稍后再试',
    error_phone: '请输入正确账号',
    next: '下一步',
    input_password: '输入新密码',
    repeat_new_password: '确认新密码',
    new_password_error: '两次密码不一致',
    submit_new_password: '提交',
    success_relogin: '密码重置成功，请重新登录',
    button_relogin: '重新登录',
    password_set: '8-20位字母及数字组合密码',
    account_info: '账号信息',
    current_account: '当前绑定账号',
    change_password: '修改密码',
    phone_find: '通过绑定手机或邮箱找回账号密码',
    not_bind_starryHub: '未绑定任何投影仪账号',
    expired: '已过期',
    account_type: '请选择账号类型',
    starryHub_account: '投影仪账号',
    czur_cloud_account: '成者云账号'
  },
  tips: {
    timeout: 'Время запроса истекло!',
    internalError: 'Внутренняя ошибка сервера!',
    networkError: 'Ошибка сетевого подключения!',
    connectError: 'Ошибка подключения (',
    errorStatus: 'Ошибка запроса(400)'
  },
  index: {
    loginText: 'CZUR Cloud',
    accountNumber: 'Аккаунт CZUR',
    password: 'Пароль',
    forgetPwd: 'Забыли пароль?',
    register: 'Регистрация',
    errorTip: 'Неверное имя пользователя или пароль',
    selectFunction: 'Выберите функцию',
    unactivated: 'Аккаунт не активирован',
    notebook: 'Блокнот',
    mobileTip: 'Данная веб-страница предназначена только для пользователей ПК.',
    youCan: 'Вы можете:',
    mobileTextOne: 'Скачать приложение "CZUR" на смартфон',
    mobileTextTwo: 'или использовать браузер на ПК для посещения веб-страницы.',
    downloadApp: 'Скачать приложение',
    countryError: 'Этот аккаунт зарегистрирован в другом регионе. Вы хотите перенаправить в зарегистрированный регион для получения соответствующих услуг?',
    countryGo: 'Подтвердить'
  },
  list: {
    noFile: 'Нет файла',
    time: 'Дата',
    category: 'Категория',
    accountCenter: 'Центр аккаунта',
    logOut: 'Выйти',
    thisday: 'В этот день',
    items: 'элем.',
    total: 'Всего',
    feedback: 'Отзывы и предложения',
    used: 'Использовано',
    back: 'Назад',
    loading: 'Загрузка…',
    loaded: 'Загружено',
    feedbackPlaceholder: 'Введите свой отзыв (не более 300 символов)',
    submit: 'Отправить',
    cancel: 'Отменить',
    feedbackSuccess: 'Успешно!',
    label: 'Метка',
    empty: 'Пусто'
  },
  player: {
    flatSinglePage: 'Один лист',
    curvePage: 'Книжный разворот',
    color: 'Цветной',
    grayscale: 'Оттенки серого',
    bw: 'Ч/Б',
    pattern: 'Шаблон',
    autoEnhance: 'Авторежим',
    copyToClipboard: 'Скопировано в буфер обмена',
    noOcrResult: 'Нет результата распознавания текста',
    ocrTip: 'Используйте распознавание рукописного текста в приложении CZUR.'
  },
  operation: {
    selected: 'Выбрано ',
    selectAllLoaded: 'Выбрать все загруженные элем. ',
    deselectAll: 'Снять выделение всех элем.',
    moveFiles: 'Переместить файлы',
    share: 'Поделиться',
    exportPDF: 'Экспорт в PDF',
    download: 'Скачать',
    delete: 'Удалить',
    moveToFolder: 'Переместить в папку',
    rename: 'Переименовать',
    confirm: 'Подтвердить',
    msg: 'Сообщение',
    moveFilesSuccess: 'Перемещение успешно',
    floderName: 'Введите имя папки',
    shareTimeLimit: 'Ограничение доступа по времени:',
    hours: 'часа',
    days: 'дней',
    createLink: 'Создать ссылку',
    shareLink: 'Поделиться ссылкой',
    password: 'Пароль',
    copy: 'Скопировать',
    createPDF: 'Создать PDF',
    pdfName: 'Введите имя PDF файла',
    pdfSet: 'Настройки',
    pdfSize: 'Размер страницы PDF',
    autoAdjustment: 'Авто',
    pdfDirection: 'Ориентация PDF',
    vertical: 'Книжная',
    horizontal: 'Альбомная',
    pdfQuality: 'Качество PDF',
    standard: 'Стандартное',
    maximum: 'Наилучшее',
    pdfCreated: 'PDF успешно создан',
    done: 'Готово'
  },
  share: {
    shareLink: 'CZUR ссылка:',
    expire: 'Срок действия ссылки',
    shared: 'Поделился *',
    enterPassword: 'Введите пароль',
    wrongPassword: 'Неверный пароль',
    fileExpired: 'Срок действия ссылки истек',
    fileDelete: 'Файл был удален',
    package: 'Подготовка…',
    shareNotebookLink: 'CZUR Notebook ссылка:'
  },
  device: {
    deviceList: 'Список устройств',
    noDevice: 'Нет устройства',
    apply: 'Использовать',
    using: 'Занято',
    bindDeviceTips: 'Используйте моб.приложение CZUR для сканирования QR-кода на основании сканера и последующей привязки к вашему аккаунту',
    gotIt: 'Понятно',
    isUsingDevice: '* использует устройство',
    unbindDevice: 'Отвязать',
    searchAccount: 'Аккаунт CZUR',
    searchMember: 'Поиск',
    transferAdministrator: 'Передать права администратора',
    deleteMember: 'Удалить пользователя',
    shareDevice: 'Совместное использование устройства',
    shareDeviceTips: '«Совместное использование устройства» разрешает использование сканера авторизованным пользователям, при этом вы остаетесь администратором.',
    noMember: 'Нет других пользователей',
    unbindDeviceTips: 'После нажатия «Отвязать» все авторизованные пользователи утратят доступ к сканеру, а данные будут сохранены в облачном хранилище CZUR Cloud. Это также произойдет в случае перезагрузки устройства.',
    unbind: 'Отвязать',
    noAccount: 'Аккаунт не существует',
    addMember: 'Добавить',
    administrator: 'Администратор',
    added: 'Добавлен',
    cancelTransfer: 'Отменить передачу',
    conformTransfer: 'Подтвердить передачу',
    ifTransferadministrator: 'Передать права администратора * ?',
    cancelDelete: 'Отменить удаление',
    confirmDelete: 'Подтвердить удаление',
    ifDeleteMember: 'Удалить пользователя?',
    and: 'и',
    others: 'другие',
    needFirmwareUpgrade: 'Обновить',
    statement: 'Уведомление',
    upgradeTest: 'Обновление облачного хранилища потребует обновления прошивки вашего сканера.',
    upgradeTestOne: '1. Включите сканер и подключите его компьютеру с помощью USB кабеля.',
    upgradeTestTwo: '2. Установите и запустите программу CZUR Scanner на вашем компьютере. ',
    upgradeTestThree: '3. В разделе «Настройки» выберите пункт «Версия прошивки» и нажмите кнопку Обновить. Завершите процесс обновления следуя указаниям программы.',
    upgradeTestFour: '4. Отключите USB кабель от сканера для его перевода в режим WI-FI (обязательно подключение к сети интернет). После перезапуска приложения CZUR функция сохранения в облачное хранилище вновь станет доступной.'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/ru.js